/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import session from "./session";

export default class {
  static saveAsIs = async (obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      if (value) {
        fd.append(key, value);
      }
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/moodboards/save`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static rateAsset = async (id, color) => {
    let result = {
      data: null,
      error: null,
    };

    const payload = {
      color: color,
    };

    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/moodboards/rate-asset/${id}`,
        payload
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static add = async (obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/moodboards`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static update = async (id, obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/moodboards/${id}`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  // Upload a user-picked image to use as the poster/thumbnail for an asset.
  static setCustomThumbnail = async (id, file) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    fd.append("file", file);

    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/moodboards/custom-thumbnail/${id}`,
        fd
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response?.data || "Failed to upload thumbnail";
      });

    return result;
  };

  // Remove the custom thumbnail and fall back to a frame from the video.
  static resetThumbnail = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/moodboards/custom-thumbnail/${id}/reset`
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response?.data || "Failed to reset thumbnail";
      });

    return result;
  };

  static copyAsset = async (assetId, targetProjectId) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/moodboards/copy-asset`, {
        assetId,
        targetProjectId,
        userId: session.get("user")?._id,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static copyToProject = async (sourceProjectId, targetProjectId) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/moodboards/copy-to-project`, {
        sourceProjectId,
        targetProjectId,
        userId: session.get("user")?._id,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static delete = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .delete(`${process.env.REACT_APP_API_URL}/moodboards/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static getStats = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .get(`${process.env.REACT_APP_API_URL}/moodboards/stats/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static saveMoodBoardsOrder = async (moodBoards) => {
    let result = {
      data: null,
      error: null,
    };

    const data = moodBoards.map((board) => ({
      _id: board._id,
      order: board.order,
    }));

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/moodboards/re-order`,
        { order: data }
      );
      if (res.status === 200) {
        result.data = res.data;
      }
    } catch (err) {
      result.error = err.response.data;
    }

    return result;
  };
}
